import * as React from 'react';
import '../../../utils/index_orig/index.esm.js';
import '../../../utils/theme/theme-provider/index.esm.js';
import { useLocalization } from '@shared-ui/localization-context';
import { getAriaLiveDate } from '../calendar-utils/intl/index.esm.js';
import { liveAnnounce, Level } from '../../../utils/live-announce/index.esm.js';
const AriaLive = ({
  customAriaLabels,
  selectionStart,
  selectionEnd,
  locale
}) => {
  const previousSelectionStartRef = React.useRef(selectionStart);
  const previousSelectionStart = previousSelectionStartRef.current;
  const previousSelectionEndRef = React.useRef(selectionEnd);
  const previousSelectionEnd = previousSelectionEndRef.current;
  const l10n = useLocalization();
  const ariaLiveScenario = React.useMemo(() => {
    const selectionStartHasChanged = selectionStart && previousSelectionStart !== selectionStart;
    if (selectionStartHasChanged) {
      return {
        state: 'NoChange',
        updateSelectionStart: true,
        date: selectionStart
      };
    }
    const selectionEndHasChanged = selectionEnd && previousSelectionEnd !== selectionEnd;
    if (selectionEndHasChanged) {
      return {
        state: 'NoChange',
        updateSelectionEnd: true,
        date: selectionEnd
      };
    }
    const areBothSelectionItemsCleared = previousSelectionStart && previousSelectionEnd && !selectionStart && !selectionEnd;
    if (areBothSelectionItemsCleared) {
      return {
        state: 'BothDatesAreCleared',
        updateSelectionStart: true,
        updateSelectionEnd: true,
        date: selectionStart
      };
    }
    const isStartSelectionCleared = previousSelectionStart && !selectionStart;
    if (isStartSelectionCleared) {
      return {
        state: 'StartDateCleared',
        updateSelectionStart: true,
        date: selectionStart
      };
    }
    const isEndSelectionCleared = previousSelectionEnd && !selectionEnd;
    if (isEndSelectionCleared) {
      return {
        state: 'EndDateCleared',
        updateSelectionEnd: true,
        date: selectionEnd
      };
    }
    return {
      state: 'NoChange'
    };
  }, [previousSelectionStart, selectionStart, previousSelectionEnd, selectionEnd]);
  if (ariaLiveScenario.updateSelectionStart) {
    previousSelectionStartRef.current = selectionStart;
  }
  if (ariaLiveScenario.updateSelectionEnd) {
    previousSelectionEndRef.current = selectionEnd;
  }
  const translationDate = getAriaLiveDate(ariaLiveScenario.date || null, locale);
  const translationKeyMap = {
    StartDateCleared: customAriaLabels?.startDateCleared || l10n.formatText('calendar.startDateCleared.a11yLabel', translationDate),
    EndDateCleared: customAriaLabels?.endDateCleared || l10n.formatText('calendar.endDateCleared.a11yLabel', translationDate),
    BothDatesAreCleared: customAriaLabels?.bothDatesCleared || l10n.formatText('calendar.datesCleared.a11yLabel', translationDate),
    NoChange: ''
  };
  const ariaLiveLabel = translationKeyMap[ariaLiveScenario.state];
  React.useEffect(() => {
    if (ariaLiveLabel) {
      liveAnnounce(ariaLiveLabel, Level.POLITE);
    }
  }, [ariaLiveLabel]);
  return null;
};
var AriaLive$1 = React.memo(AriaLive);
export { AriaLive$1 as default };